<template>
    <div class="news-more">
        <div>
            <img style="width: 100%" src="../assets/images/v2_s3sqsj.jpg" alt="">
        </div>
        <div class="news-list">
            <div v-for="(item, index) in newsList">
                <div class="news-item">
                    <div class="news-date">
                        <div style="font-weight: bold; font-size: 50px">
                            {{item.date}}
                        </div>
                        <div>
                            {{item.month}}
                        </div>
                    </div>
                    <div class="news-info" @click="handleClick(item.id)">
                        <div class="news-info-title">
                            {{item.title}}
                        </div>
                        <div class="news-info-text">
                            {{item.zhaiyao}}
                        </div>
                    </div>
                    <div class="news-img">
                        <img style="height: 100%;object-fit: contain;" :src=item.img alt="">
                    </div>
                </div>

                <div v-if="index !== newsList.length - 1" class="bottom-line"></div>

            </div>

        </div>
        <div class="pagination">
            <el-pagination
                    v-model:current-page="currentPage"
                    :page-size="100"
                    layout="prev, pager, next"
                    :total="1000"
                    @current-change="handleCurrentChange"
                    align="center"
                    background/>

        </div>
    </div>
</template>

<script>
import {getNewsImage, getNewsList} from "@/api/user";

export default {
  name: "NewsMore",
  data() {
    return {
      currentPage: 1,
      newsList: [
        {
          date: '14',
          month: '2023-12',
          title: '平常的调研，不平常的部署',
          text: '应中南大学邹滨教授邀请，湖南省生态环境厅环境监测处处长金杰坤、湖南省生态环境监测中心主任余涛、湖南省生态环境厅环境监测处副处长丁华、湖南省生态环境监测中心生态部部长易敏、湖南省生态环境监测中心大气部部长郭卉等一行……',
          img: require('@/assets/images/img_2.png')
        },{
          date: '12',
          month: '2023-10',
          title: '事关重大部署，书记亲临现场主持项目验收',
          text: '2023年10月12日，应项目课题组邀请，常德市自然资源和规划局党组书记、局长宋磊，常德市自然资源和规划局副局长张辉，常德市自然资源和规划局办公室主任唐家新等领导专家一行5人亲临省会长沙听取了“常德市碳汇监测试点”项目成果验收汇报"……',
          img: require("../assets/images/img_4.png")
        },{
          date: '12',
          month: '2023-07',
          title: '用真技术赢得客户信任',
          text: '应中国环境监测总站邀请，我司首席科学家、中南大学地球科学与信息物理学院邹滨教授及其科研骨干成员等一行前往临湘市调研大气污染防治工作进展情况，我司研究院院长郑超应邀随同参与了本次调研交流会……',
          img: require("@/assets/images/img_3.png")
        }
      ]
    }
  },
  methods: {
    handleClick(id) {
      this.$router.push({ name: 'newsDetail', params: { userId: '123' }, query:{
          newsId: id
        }})
      // router.push({ name: 'newsDetail', params: { userId: '123' }})
    },
    handleCurrentChange() {
      getNewsList("", this.currentPage - 1, 5).then((res) => {
        this.newsList = res.data.data
        console.log(res.data.data);
        this.newsList.forEach(item => {
          item.date = item.pubTime.substring(8, 10)
          item.month = item.pubTime.substring(0, 7)
          item.imageShow = false
          getNewsImage(item.suoluetu).then(res => {
            const url = window.URL.createObjectURL(res)
            item.img = url
            // item.imageShow = true
          })
        })
      })
    }
  },
  mounted() {
    getNewsList("", this.currentPage - 1, 5).then((res) => {
      this.newsList = res.data.data
      console.log(res.data.data);
      this.newsList.forEach(item => {
        item.date = item.pubTime.substring(8, 10)
        item.month = item.pubTime.substring(0, 7)
        item.imageShow = false
        getNewsImage(item.suoluetu).then(res => {
          const url = window.URL.createObjectURL(res)
          item.img = url
          // item.imageShow = true
        })
      })
    })
  }
}
</script>

<style scoped>
.news-more {

    .news-list {

        .news-item {
            display: flex;
            flex-direction: row;
            width: 100%;
            position: relative;
            padding: 30px;
            box-sizing: border-box;
            height: 250px;
            align-items: center;
            justify-content: space-between;
            /*border-top: 1px solid gray;*/
            .news-date {
                position: relative;
                width: 15%;
                color: #0524CC;
            }
            .news-info {
                position: relative;
                flex: 1;
                padding: 0 40px;
                .news-info-title {
                    font-size: 30px;
                    font-weight: bold;
                    margin-bottom: 30px;
                }
                .news-info-text {
                    font-size: 20px;
                    color: #898989;
                    text-align: left;
                }
            }
            .news-img {
                position: relative;
                width: 20%;
                height: 100%;
            }

        }
        .news-item:hover { cursor:pointer;background-image: linear-gradient(to bottom, rgba(1, 1, 1, 0.05), white); }
        .bottom-line {
            width: calc(100% - 2px);
            height: 0;
            border: 1px solid #898989;;
        }

    }

    .pagination {
        padding: 30px 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}

</style>